import { useState } from 'react';
import { Button } from '@/components/ui/button';
import IncidentNewSeatDialog from '../IncidentNewSeatDialog';
import AddChildPositionDialog from './AddChildPositionDialog';

/**
 * Add / manage seats for the Hub template editor. Lives next to Templates so
 * those controls share one row with the Roster Template heading.
 */
export default function RosterTemplateSeatActions() {
  const [addSeatOpen, setAddSeatOpen] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setAddSeatOpen(true)}
      >
        + Add Seat
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setManageOpen(true)}
      >
        Manage Custom Incident Seats
      </Button>
      {addSeatOpen ? (
        <AddChildPositionDialog show onClose={() => setAddSeatOpen(false)} />
      ) : null}
      {manageOpen ? (
        <IncidentNewSeatDialog show onClose={() => setManageOpen(false)} />
      ) : null}
    </>
  );
}
